import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './App.css';
import { selectUser, login, logout } from './features/userSlice';
import Login from "./components/Login";
import { auth } from './firebase';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import History from './pages/History';
import History2 from './pages/History2';

/**
 *  For firebase deployment:
 *    - npm run build
 *    - firebase init
 *    - selection hosting
 *    - Use "build"
 *    - No single page
 *    - No overwrite
 *    - firebase deploy
 */

function App() {

  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  useEffect(() => {
    auth.onAuthStateChanged(authUser => {
      if (authUser) {
        dispatch(login({
          uid: authUser.uid,
          photo: authUser.photoURL,
          email: authUser.email,
          displayName: authUser.displayName,
        }));
      } else {
        dispatch(logout());
      }
    })

    // Comment below disable warning for useEffect() method:
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <div className="App">
      {user ? 
        <Router>
          <Switch>
            <Route exact path='/' component={Home} />
            <Route exact path='/about' component={About} />
            <Route exact path='/history' component={History} />
          </Switch>
        </Router> 
        : 
        <Login />}
    </div>
  );
}

export default App;
